import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { tuple } from '../_utils/type';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
export var SpinTypes = tuple('page', 'container', 'component');
// remove this line and code Spin component here
var InteranalSpin = function InteranalSpin(props, ref) {
  var _context, _classNames;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var spinProps = getCompProps('Spin', userDefaultProps, props);
  var children = spinProps.children,
    className = spinProps.className,
    indicator = spinProps.indicator,
    spinning = spinProps.spinning,
    style = spinProps.style,
    tip = spinProps.tip,
    type = spinProps.type,
    customPrefixcls = spinProps.prefixCls,
    others = __rest(spinProps, ["children", "className", "indicator", "spinning", "style", "tip", "type", "prefixCls"]);
  devWarning(SpinTypes.indexOf(type) === -1, 'spin', "cannot found spin type '".concat(type, "'"));
  var spinPrefixCls = getPrefixCls(prefixCls, 'spin', customPrefixcls);
  var spinClasses = classNames(spinPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(spinPrefixCls, "-")).call(_context, type), type), _defineProperty(_classNames, "".concat(spinPrefixCls, "-indicator-container"), true), _defineProperty(_classNames, "".concat(spinPrefixCls, "-has-children"), children), _classNames));
  // ref
  var thisSpinRef = useRef();
  var spinRef = ref || thisSpinRef;
  var handleIndicator = function handleIndicator(indicator) {
    if (indicator) {
      return indicator;
    }
    switch (type) {
      case 'page':
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(spinPrefixCls, "-dot-spin")
        }, /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }), /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }), /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }), /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }));
      case 'container':
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(spinPrefixCls, "-dot-spin")
        }, /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }), /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }), /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }), /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }));
      case 'component':
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(spinPrefixCls, "-dot-spin")
        }, /*#__PURE__*/React.createElement("i", {
          className: "".concat(spinPrefixCls, "-dot-item")
        }));
    }
  };
  var indicatorNode = handleIndicator(indicator);
  var hasChildrenStyle = children ? style : null;
  var singleStyle = children ? null : style;
  var hasChildrenRef = children ? spinRef : null;
  var singleRef = children ? null : spinRef;
  var spinNode = spinning ? /*#__PURE__*/React.createElement("div", _extends({
    className: spinClasses,
    ref: singleRef,
    style: singleStyle
  }, others), indicatorNode, tip || '') : null;
  var childrenParentClasses = classNames(_defineProperty({}, "".concat(spinPrefixCls, "-children-container"), children && spinning));
  var spinHasChildren = children ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(spinPrefixCls, "-children-wrapper"),
    style: hasChildrenStyle,
    ref: hasChildrenRef
  }, spinNode, /*#__PURE__*/React.createElement("div", {
    className: childrenParentClasses
  }, children)) : spinNode;
  return spinHasChildren;
};
var Spin = /*#__PURE__*/React.forwardRef(InteranalSpin);
Spin.displayName = 'Spin';
export default Spin;